import { Routes } from '@angular/router';
import { permissionGuard } from '@core/auth/permission.guard';
import { APP_PERMISSIONS } from '@core/constants/permission.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const climateScenariosRoutes: Routes = [
  {
    title: 'pagesTitles.climateScenarios',
    path: APP_ROUTES.CLIMATE_SCENARIOS,
    canActivate: [permissionGuard(APP_PERMISSIONS.ClimateScenarioRead)],
    loadComponent: () =>
      import('./pages/climate-scenarios-list').then((m) => m.ClimateScenariosList),
  },
];
